import { useQuery } from 'react-query';
import axios from 'axios';
import { RatingAPI } from '../../../constants/API';
import { commonHeaders } from '../../../constants/HeadersAPI';
import { RatingSettingsDto } from '../../../types/Rating/RatingTypes';

export const useGetRatingSettings = (branchQueueId: number | null) => {
  return useQuery(
    ['ratingSettings', branchQueueId],
    async () => {
      const { data } = await axios.get<RatingSettingsDto>(
        RatingAPI.getSettings(branchQueueId!),
        commonHeaders()
      );
      return data;
    },
    { enabled: branchQueueId != null && branchQueueId > 0 }
  );
};
